@if (links) {
	@for (link of links; track link.routerLink) {
		<a [routerLink]="link.routerLink" class="button" routerLinkActive="active" >
			<span class="text">{{ link.text }}</span>
		</a>
	}
}
